import React, {useState} from "react"
import MetaTags from 'react-meta-tags';
import {
  Container, 
  Card, CardBody,
} from "reactstrap"
import Select from "react-select"
import { Link, useHistory } from "react-router-dom"
import { get, post } from "../../../helpers/api_helper"
import * as url from "../../../helpers/url_helper"
import moment from 'moment';
import { connect } from "react-redux"


import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';

const AlertSummary = props => {

  const history = useHistory();

  const [selectedDateOption, setSelectedDateOption] = React.useState({ label: 'weekly', value: 'weekly' });
  const [startDate, setStartDate] = React.useState(moment().subtract(1, 'week').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = React.useState(moment().format('YYYY-MM-DD'));

  const [data, setData] = React.useState([]);

  const [errors, setErrors] = React.useState([]);
  
  const [loading, setLoading] = React.useState(true);

  const dateOptions = [
    { label: 'weekly', value: 'weekly' },
    { label: 'monthly', value: 'monthly' }
  ];

  const columns = [{
    dataField: 'slno',
    text: '#',
  },
  {
    dataField: 'asset_name',
    text: 'Asset name',
  }, 
  {
    dataField: 'total',
    text: 'Alert count',
  }, 
  ];

  const handleSubmit = () => {

    let data = {
      'start_date': startDate,
      'end_date': endDate,
      // property_id: props.filterProperty.id,
      block_id: props.filterBlock.id,
    };

    console.log('data', data);

    setLoading(true);
    setErrors([]);

    post(url.POST_ALERTSUMMARY, data)
    .then((response) => {
      console.log('RESP', response);
      if(response.status == 200) {
        setData(response.data)
      }
      else if(response.status == 400) {
        setErrors(Object.values(response.error));
      }
      else {
        console.log('err::', response);
      }
    }, (error) => {
      console.log(error);
      setLoading(false);
    });
  };



  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Alert Summary | Digital Logbook</title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="mb-4">Alert Summary</h3>
            {/* <Link className="btn btn-secondary" to="/activities/index">Back</Link> */}
          </div>

          <Card>
            <CardBody>
              {/* <CardTitle tag="h3">BASIC DETAILS</CardTitle> */}
              {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
              <div className="row">
                <div className="col">
                  <div className="">
                    <label className="label form-label">&nbsp;</label>
                    <Select
                        classNamePrefix="select2-selection"
                        placeholder="Select one..."
                        title="Set to..."
                        options={dateOptions}
                        value={selectedDateOption}
                        onChange={e => { 
                          if(e.value == 'weekly') {
                            setStartDate(moment().subtract(1, 'week').format('YYYY-MM-DD'));
                            setEndDate(moment().format('YYYY-MM-DD'));
                          }
                          else if(e.value == 'monthly') {
                            setStartDate(moment().subtract(1, 'month').format('YYYY-MM-DD'));
                            setEndDate(moment().format('YYYY-MM-DD'));
                          }
                            setSelectedDateOption(e); 
                        }}
                        />
                  </div>
                </div>
                <div className="col">
                  <div className="">
                    <label className="label form-label">From</label>
                    <input type="text" className="form-control" id="dateFrom"
                      type="date"
                      value={startDate} onChange={e => { 
                        setStartDate(e.target.value); 
                        setSelectedDateOption(null);
                      }}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="">
                    <label className="label form-label">To</label>
                    <input type="text" className="form-control" id="dateFrom"
                      type="date"
                      value={endDate} onChange={e => { 
                        setEndDate(e.target.value); 
                        setSelectedDateOption(null);
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-center mt-4">
                <button type="button" className="btn btn-primary" onClick={() => { handleSubmit(); }}>Generate</button>
              </div>

            </CardBody>
          </Card>

          <Card>
            <CardBody>
              {/* <CardTitle tag="h3">Forms</CardTitle> */}
              {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
              <BootstrapTable striped
                bordered={false}
                wrapperClasses="table-responsive" className="border border-danger" keyField='id' data={ data } columns={ columns } filter={ filterFactory() } pagination={ paginationFactory() } />
            </CardBody>
          </Card>

     </Container>

      </div>
    </React.Fragment>
  )
}

const mapStatetoProps = (state) => {
  const {
    filterBlock,
    filterProperty
  } = state.filters
  return { filterBlock, filterProperty }
}

export default connect(mapStatetoProps)(AlertSummary)